var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"v8OsWO4VJz5hwch3D3fHG"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/160";

import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://d6f4d68e7e7a429d836e8db86d2c07dd@o1050646.ingest.sentry.io/4504642315812864',
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});
